import RequestServiceFormPage from "./RequestServiceFormPage";
import RequestQuoteFormPage from "./RequestQuoteFormPage";
import ContactUsFormPage from "./ContactUsFormPage";
import BecomeDealerFormPage from "./BecomeDealerFormPage";

// routes to form pages
export default [
  { path: "/request-quote", component: RequestQuoteFormPage },
  { path: "/request-service", component: RequestServiceFormPage },
  { path: "/contact-us", component: ContactUsFormPage },
  { path: "/become-dealer", component: BecomeDealerFormPage },
];
